import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { LogoMark } from './LogoMark';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
} from '@backstage/core-components';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { PsAgentSidebarItem } from '../agent/PsAgentSidebarItem';
import {
  CreateComponentIcon,
  DocsIcon,
  GroupIcon,
  HomeIcon,
  ImageIcon,
  MenuIcon,
  SearchIcon,
} from '../ui/sidebarIcons';
import styles from './Root.module.css';
import logoStyles from './Logo.module.css';

const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div
      className={styles.logoRoot}
      style={{ height: 3 * sidebarConfig.logoHeight }}
    >
      <Link to="/" className={styles.logoRow} aria-label="Home">
        <div
          className={styles.iconColumn}
          style={{
            width: sidebarConfig.drawerWidthClosed,
            minWidth: sidebarConfig.drawerWidthClosed,
          }}
        >
          <LogoMark
            className={logoStyles.mark}
            style={{ height: sidebarConfig.iconSize }}
          />
        </div>
        {isOpen && <span className={logoStyles.brandText}>Redis</span>}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={SearchIcon} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={MenuIcon}>
        <SidebarItem icon={HomeIcon} to="catalog" text="Home" />
        <SidebarItem icon={ImageIcon} to="images" text="Images" />
        <MyGroupsSidebarItem
          singularTitle="My Group"
          pluralTitle="My Groups"
          icon={GroupIcon}
        />
        <SidebarItem icon={DocsIcon} to="docs" text="Docs" />
        <PsAgentSidebarItem />
        <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
        <SidebarDivider />
        <SidebarScrollWrapper />
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <NotificationsSidebarItem />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={UserSettingsSignInAvatar}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
